<template>
  <div
    class="steps"
  >
    <img
      class="display w-20 lg:hidden"
      src="@/assets/img/plant-vase.png"
      alt="plant vase"
    />
    <h2 class="text-2xl text-grey-2 font-medium mb-7 lg:mb-6 lg:hidden">{{$t('auto_investment.setup.title_sidebar_1')}} {{	$t('auto_investment.self')}} {{	$t('auto_investment.setup.title_sidebar_2')}}</h2>
    <p class="text-sm lg:text-xl text-grey-2 font-bold mb-7 lg:mb-6">{{$t('auto_investment.setup.first_step.title')}}</p>
    <p class="text-sm text-grey-2 text-opacity-80 text-left mb-4 lg:mb-8">{{$t('auto_investment.setup.first_step.text')}}</p>
    <a @click="openPopup" class="orange-link">
      {{$t('auto_investment.setup.first_step.link')}}
    </a>
    <GpButton
      mobileWidth="w-4/5"
      class="absolute mt-8 lg:right-24 mx-auto lg:m-0"
      @click="next"
    >
      {{$t('auto_investment.setup.title_sidebar_1')}} {{	$t('auto_investment.self')}}
    </GpButton>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import GpButton from '@/components/general/GpButton.vue'
import {useI18n} from "vue-i18n";

export default {
  components: {
    GpButton
  },
  setup(props, { emit }) {
    const store = useStore()
    const i18n = useI18n({ useScope: 'global' })

    const openPopup = () => {
      const popup = {
        align: 'center',
        side: true,
        title: i18n.t('auto_investment.setup.first_step.title'),
        component: 'AutoInvestDetails'
      }
      store.dispatch('setPopup', popup)
	  }

    async function next() {
      emit('next')
    }

    return {
      openPopup,
      next
    }
  }
}
</script>